import type { IAppState } from 'shared/common/state';

export const selectEtazhiBlackFridayIsEnabledByRegion = (state: IAppState): boolean => {
  return Boolean(state.etazhiBlackFriday?.isEnabledByRegion);
};
